import { IDoctorForDocument, IPrescription, ITransmittable } from '@alberta/konexi-shared';
import { IPrescriptionRequest } from '@alberta/konexi-shared/dist/prescription/prescription-request';
import { AuditData } from '@alberta/swodoc-document-generator/dist/domain/Audit/Audit';

import { AggregateRoot } from '../aggregate-root';

export class PrescriptionRequestDto extends AggregateRoot implements IPrescriptionRequest {
  patientId: string;
  regionId: string;
  singleOrderId: string;
  templateId: string;
  integratedCareId?: string;
  correspondenceType: ITransmittable['correspondenceType'];
  reminderLevel?: number;
  to: string;
  salutationCode?: string;
  doctor: IDoctorForDocument;
  patient: {
    customerNumber: string;
    name: string;
    additionalName: string;
    address: string;
    postalCode: string;
    city: string;
    birthday: string;
  };
  payer: {
    name: string;
    numberOfInsured: string;
  };
  bodyTexts: string[];
  prescriptions: IPrescription[];
  additionalProperties: AuditData;
  status: ITransmittable['status'];
  retry: number;
  faxProvider: string;
  faxProviderId: string;
  lastError: string;
  mimeType: string;
  fileUrl: string;
  fileName: string;
  subject: string;
  body: string;
  history: { status: string; lastError?: string; retry?: number; timestamp: Date }[];
  diagnose: string;
  startDate: Date;
  endDate: Date;
  replyTo: string;
  attachments: {
    _id: string;
    filename: string;
    contentType: string;
  }[];

  constructor() {
    super();
  }
}
